import React from "react";
import "./AppraisalSetup.css";
import Header from "./AppraisalList/component/Header/Header";
import AppraisalSetupList from "./AppraisalList/AppraisalSetupList";

const AppraisalSetup = () => {
  return (
    <div>
      <Header />
      <AppraisalSetupList />
    </div>
  );
};

export default AppraisalSetup;
